import { render, staticRenderFns } from "./DiseaseAnalysisPage.vue?vue&type=template&id=42cdb0dd&scoped=true"
import script from "./DiseaseAnalysisPage.vue?vue&type=script&lang=js"
export * from "./DiseaseAnalysisPage.vue?vue&type=script&lang=js"
import style0 from "./DiseaseAnalysisPage.vue?vue&type=style&index=0&id=42cdb0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cdb0dd",
  null
  
)

export default component.exports